module.exports = __webpack_public_path__ + "static/img/bg-en.b943d5b0.png";